import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

export const useIndicatorKey = () => {
  const location = useLocation();
  const { strategyId, dateRange, universe } = useParams<{
    strategyId: string;
    dateRange: string;
    universe: string;
  }>();

  // Stable params to avoid unnecessary refetches
  const baseParams = useMemo(
    () => ({ strategyId: strategyId!, dateRange, universe }),
    [strategyId, dateRange, universe]
  );

  const key = useMemo(() => {
    if (baseParams.dateRange) {
      return `${baseParams.universe?.toLowerCase()}_${baseParams.dateRange?.toUpperCase()}_${baseParams.strategyId?.toLowerCase()}`;
    } else if (location.pathname === "/draft") {
      return `draft`;
    } else if (location.pathname.endsWith("/draft")) {
      return `${baseParams.strategyId}_draft`;
    } else {
      return `${baseParams.strategyId}`;
    }
  }, [
    baseParams.strategyId,
    baseParams.dateRange,
    baseParams.universe,
    location.pathname,
  ]);

  return {
    strategyId: baseParams.strategyId,
    dateRange: baseParams.dateRange,
    universe: baseParams.universe,
    key,
  };
};
